import { ApolloError, useLazyQuery, useMutation } from "@apollo/client";
import { EMPLOYEES_BY_AGENCY_ID, GET_ALL_CUSTOMER_EMAILS, GET_ALL_TICKETS } from "../../api/query";
import { useEffect, useMemo, useState } from "react";
import Loader from "../../components/common/Loader";
import DynamicTable from "../../components/common/DynamicTable";
import { format, isBefore, parse, parseISO } from "date-fns";
import { useNavigate } from "react-router-dom";
import { SortingState } from "@tanstack/react-table";
import BreadCumb from "../../components/common/Breadcrumb";
import backArrow from "../../assets/task/back_arrow.svg";
import rePlayicon from "../../assets/task/Replay.svg";
import ticketLineicon from "../../assets/task/Ticket text line.svg";
import emailOpen from "../../assets/Email_open-01.svg";
import archiveInicon from "../../assets/task/Archive in.svg";
import emailOpenicon from "../../assets/task/Email open.svg";
import searchsIconimg from "../../assets/task/search-5-svgrepo-com.svg";
import cleaAlldetaicon from "../../assets/task/clear-reflect-horizontal-svgrepo-com.svg";
import PreferencesSystemicon from "../../assets/task/Preferences-system-details-symbolic.svg";
import { useAuth } from "../../context/AuthContext";
import * as yup from "yup";
import { Controller, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import ReplyPopup from "../../components/customerSuccess/ReplyPopup";
import { CUSTOMER_EMAIL_ACTIONS } from "../../api/mutation";
import { showError, showSuccess } from "../../components/common/ToastNotification";
import ChangeStatusPriorityPopup from "../../components/customerSuccess/ChangeStatusPriorityPopup";
import DateSelector from "../../components/common/DateSelector";

const employeeTaskSchema = yup.object().shape({
    assignedMemberID: yup.string().required("Employee is required"),
    assignedMember: yup.string().required("Employee is required"),
    start_date: yup.date(),
    end_date: yup.date()
});

const CsDashboard = () => {
    const navigate = useNavigate();
    const { userInfo } = useAuth()

    const employeeID = userInfo?.employee_id;
    const organizationID = userInfo?.agencies?.id || '';
    const employeeEmail = userInfo?.email_id
    const employeeName = `${userInfo?.first_name} ${userInfo?.last_name}`

    const filterLabel = localStorage.getItem("csdashFilter");
    const subFilterLabel = localStorage.getItem("csdashSubFilter");

    //constants
    const [sorting, setSorting] = useState<SortingState>([]);
    const [selectedRows, setSelectedRows] = useState<Set<string>>(new Set());
    const [mainTable, setMainTable] = useState<any>(null);
    const [mainTableUpdate, setMainTableUpdate] = useState(false);
    const [assignedMemberOptions, setAssignedMemberOptions] = useState<{ key: string; name: string }[]>([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState<number>(0);
    const [isPopupOpen, setIsPopupOpen] = useState(false)
    const [selectedEmail, setSelectedEmail] = useState({})
    const [loading, setLoading] = useState(false);
    const [selectedFilter, setSelectedFilter] = useState(filterLabel || "Home")
    const [selectedSubFilter, setSelectedSubFilter] = useState(subFilterLabel || "Not Replied")
    const [openChangePopup, setOpenChangeOpen] = useState(false)
    const [changeStatusID, setChangeStatusID] = useState('')

    //api
    const [getAllCustomerEmails, { data: customerEmailsData, loading: customerEmailsLoading }] = useLazyQuery(GET_ALL_CUSTOMER_EMAILS, {
        fetchPolicy: 'no-cache'
    })

    const [getAllTickets, { data: customerTicketsData, loading: customerTicketsLoading }] = useLazyQuery(GET_ALL_TICKETS, {
        fetchPolicy: 'no-cache'
    })

    const [customerEmailAction, { loading: customerEmailActionLoading }] = useMutation(CUSTOMER_EMAIL_ACTIONS, {
        fetchPolicy: 'no-cache',
    })

    const [
        getEmployeesByAgencyID,
        { data: employeesData, loading: employeesDataLoading },
    ] = useLazyQuery(EMPLOYEES_BY_AGENCY_ID, {
        fetchPolicy: 'no-cache'
    });

    const {
        setValue,
        watch,
        control,
        trigger,
        getValues,
        formState: { errors }
    } = useForm<any>({
        resolver: yupResolver(employeeTaskSchema),
    });

    useEffect(() => {
        if (filterLabel) {
            setSelectedFilter(filterLabel);
        }

        if (subFilterLabel) {
            setSelectedSubFilter(subFilterLabel)
        }

        if (organizationID) {
            getEmployeesByAgencyID({
                variables: {
                    agency_id: parseInt(organizationID)
                }
            });
        }
    }, [organizationID])


    useEffect(() => {
        // const selectedMonth = parseInt(watchMonth);
        // const selectedYear = parseInt(watchYear);

        // if (watchAssignedMemberID && watchStartDate && watchEndDate) {
        if (selectedFilter === "Home" && selectedSubFilter === "All") {
            getAllCustomerEmails({
                variables: {
                    is_archived: false,
                    is_follow_up_required: false,
                    page: 1,
                    page_size: 50,
                    start_date: getValues('start_date') ? getValues('start_date') : null,
                    end_date: getValues('end_date') ? getValues('end_date') : null
                }
            });
        } else if (selectedFilter === "Home" && selectedSubFilter === "Replied") {
            getAllCustomerEmails({
                variables: {
                    is_archived: false,
                    is_follow_up_required: false,
                    is_replied: true,
                    page: 1,
                    page_size: 50,
                    start_date: getValues('start_date') ? getValues('start_date') : null,
                    end_date: getValues('end_date') ? getValues('end_date') : null
                }
            });
        } else if (selectedFilter === "Home" && selectedSubFilter === "Not Replied") {
            getAllCustomerEmails({
                variables: {
                    is_archived: false,
                    is_follow_up_required: false,
                    is_replied: false,
                    page: 1,
                    page_size: 50,
                    start_date: getValues('start_date') ? getValues('start_date') : null,
                    end_date: getValues('end_date') ? getValues('end_date') : null
                }
            });
        } else if (selectedFilter === "followUp") {
            getAllCustomerEmails({
                variables: {
                    is_archived: false,
                    is_follow_up_required: true,
                    page: 1,
                    page_size: 50
                }
            });
        } else if (selectedFilter === "Ticket") {
            getAllTickets({
                variables: {
                    page: 1,
                    page_size: 50
                }
            });
        } else if (selectedFilter === "Archive") {
            getAllCustomerEmails({
                variables: {
                    is_archived: true,
                    page: 1,
                    page_size: 50
                }
            });
        }
        // }
    }, [selectedFilter, selectedSubFilter]);

    useEffect(() => {
        if (employeesData && employeesData.employees_by_agency_id) {
            const employeeOptions = employeesData?.employees_by_agency_id?.employees?.map((emp: any) => ({
                key: emp.employee_id,
                name: `${emp.first_name} ${emp.last_name}`
            }));
            setAssignedMemberOptions(employeeOptions);

            const defaultMember = employeeOptions?.find((member: any) => member.key == employeeID);

            if (defaultMember) {
                // Set default assigned member
                setValue('assignedMemberID', defaultMember.key);
                setValue('assignedMember', defaultMember.name);
                // trigger('assignedMember');
            } else {
                // Clear if employeeID not found in members
                setValue('assignedMemberID', '');
                setValue('assignedMember', '');
            }
        }
    }, [employeesData])

    const getColumns = (selectedFilter: string) => {
        if (selectedFilter === "Ticket") {
            return [
                {
                    key: "title",
                    name: "Title",
                    id: "title",
                    header: "Title",
                    accessorKey: "title",
                    enableSorting: true,
                    sortingFn: (rowA: any, rowB: any, columnId: any) => {
                        const valueA = String(
                            rowA.getValue(columnId) || ""
                        ).toLowerCase();
                        const valueB = String(
                            rowB.getValue(columnId) || ""
                        ).toLowerCase();
                        return valueA.localeCompare(valueB);
                    },
                },
                {
                    key: "severity",
                    name: "Severity",
                    id: "severity",
                    header: "Severity",
                    accessorKey: "severity",
                    enableSorting: true,
                    sortingFn: (rowA: any, rowB: any, columnId: any) => {
                        const valueA = String(
                            rowA.getValue(columnId) || ""
                        ).toLowerCase();
                        const valueB = String(
                            rowB.getValue(columnId) || ""
                        ).toLowerCase();
                        return valueA.localeCompare(valueB);
                    },
                },
                {
                    key: "status",
                    name: "Status",
                    id: "status",
                    header: "Status",
                    accessorKey: "status",
                    enableSorting: true,
                    sortingFn: (rowA: any, rowB: any, columnId: any) => {
                        const valueA = String(
                            rowA.getValue(columnId) || ""
                        ).toLowerCase();
                        const valueB = String(
                            rowB.getValue(columnId) || ""
                        ).toLowerCase();
                        return valueA.localeCompare(valueB);
                    },
                },
                {
                    key: "created_on",
                    name: "Created On",
                    id: "created_on",
                    header: "Created On",
                    accessorKey: "created_on",
                    enableSorting: true,
                    sortingFn: (rowA: any, rowB: any) => {
                        const startDateA = rowA?.getValue("created_on");
                        const startDateB = rowB?.getValue("created_on");

                        // If a start_date is missing (null or undefined), treat it as the latest date.
                        // You can also treat missing dates as the earliest date by using `new Date(0)` instead of `new Date()`
                        const defaultDate = new Date(0); // You can change this to `new Date()` if you want it sorted to the end.

                        const dateA = startDateA ? parse(startDateA, "MM-dd-yyyy", new Date()) : defaultDate;
                        const dateB = startDateB ? parse(startDateB, "MM-dd-yyyy", new Date()) : defaultDate;

                        // Ensure valid date parsing, otherwise fallback to defaultDate
                        if (isNaN(dateA.getTime())) {
                            dateA.setTime(defaultDate.getTime());
                        }
                        if (isNaN(dateB.getTime())) {
                            dateB.setTime(defaultDate.getTime());
                        }

                        // Compare the full dates directly (ascending or descending will be handled by react-table)
                        return dateA.getTime() - dateB.getTime();
                    },
                },
                {
                    key: "action",
                    name: "Action",
                    id: "action",
                    header: "Action",
                    accessorKey: "action",
                    hideSearch: true,
                    cell: ({ row }: any) => {
                        const original = row?.original
                        return (
                            <div className="flex gap-[8px]">
                                <button
                                    className="emptasklist-tbl-btn cursor-pointer"
                                    onClick={() => {
                                        navigate('/view_ticket', {
                                            state: {
                                                ticket: original
                                            }
                                        })
                                    }}
                                >
                                    <span className="text-sm dark:text-white" title="View Ticket"> <img src={PreferencesSystemicon} className="w-6 h-6 object-cover cursor-pointer" alt="" /></span>
                                </button>
                                <button
                                    className="emptasklist-tbl-btn cursor-pointer"
                                    onClick={() => handleArchive(original?.id)}
                                >
                                    <span className="text-sm dark:text-white" title="Archive"><img src={archiveInicon} className="w-6 h-6 object-cover cursor-pointer" alt="" /></span>
                                </button>
                            </div>
                        );
                    },
                },
            ]
        } else {
            return [
                {
                    key: "s_no",
                    name: "S.No.",
                    id: "s_no",
                    header: "S.No.",
                    accessorKey: "s_no",
                    enableSorting: false,
                    cell: ({ row }: any) => {
                        return <span>{row?.original?.s_no}</span>;
                    },
                },
                {
                    key: "label",
                    name: "Label",
                    id: "label",
                    header: "Label",
                    accessorKey: "label",
                    enableSorting: true,
                    sortingFn: (rowA: any, rowB: any, columnId: any) => {
                        const valueA = String(
                            rowA.getValue(columnId) || ""
                        ).toLowerCase();
                        const valueB = String(
                            rowB.getValue(columnId) || ""
                        ).toLowerCase();
                        return valueA.localeCompare(valueB);
                    },
                },
                {
                    key: "agency_name",
                    name: "Agency Name",
                    id: "agency_name",
                    header: "Agency Name",
                    accessorKey: "agency_name",
                    enableSorting: true,
                    sortingFn: (rowA: any, rowB: any, columnId: any) => {
                        const valueA = String(
                            rowA.getValue(columnId) || ""
                        ).toLowerCase();
                        const valueB = String(
                            rowB.getValue(columnId) || ""
                        ).toLowerCase();
                        return valueA.localeCompare(valueB);
                    },
                },
                {
                    key: "received_date",
                    name: "Date Received",
                    id: "received_date",
                    header: "Date Received",
                    accessorKey: "received_date",
                    enableSorting: true,
                    sortingFn: (rowA: any, rowB: any) => {
                        const startDateA = rowA?.getValue("received_date");
                        const startDateB = rowB?.getValue("received_date");

                        // If a start_date is missing (null or undefined), treat it as the latest date.
                        // You can also treat missing dates as the earliest date by using `new Date(0)` instead of `new Date()`
                        const defaultDate = new Date(0); // You can change this to `new Date()` if you want it sorted to the end.

                        const dateA = startDateA ? parse(startDateA, "MM-dd-yyyy", new Date()) : defaultDate;
                        const dateB = startDateB ? parse(startDateB, "MM-dd-yyyy", new Date()) : defaultDate;

                        // Ensure valid date parsing, otherwise fallback to defaultDate
                        if (isNaN(dateA.getTime())) {
                            dateA.setTime(defaultDate.getTime());
                        }
                        if (isNaN(dateB.getTime())) {
                            dateB.setTime(defaultDate.getTime());
                        }

                        // Compare the full dates directly (ascending or descending will be handled by react-table)
                        return dateA.getTime() - dateB.getTime();
                    },
                },
                {
                    key: "from",
                    name: "From",
                    id: "from",
                    header: "From",
                    accessorKey: "from",
                    enableSorting: true,
                    sortingFn: (rowA: any, rowB: any, columnId: any) => {
                        const valueA = String(
                            rowA.getValue(columnId) || ""
                        ).toLowerCase();
                        const valueB = String(
                            rowB.getValue(columnId) || ""
                        ).toLowerCase();
                        return valueA.localeCompare(valueB);
                    },
                },
                {
                    key: "subject",
                    name: "Subject",
                    id: "subject",
                    header: "Subject",
                    accessorKey: "subject",
                    enableSorting: true,
                    sortingFn: (rowA: any, rowB: any, columnId: any) => {
                        const valueA = String(
                            rowA.getValue(columnId) || ""
                        ).toLowerCase();
                        const valueB = String(
                            rowB.getValue(columnId) || ""
                        ).toLowerCase();
                        return valueA.localeCompare(valueB);
                    },
                },
                // Conditionally add Subject column
                ...(selectedFilter === "Home" && selectedSubFilter === "All"
                    ? [
                        {
                            key: "status",
                            name: "Status",
                            id: "status",
                            header: "Status",
                            accessorKey: "status",
                            enableSorting: true,
                            sortingFn: (rowA: any, rowB: any, columnId: any) => {
                                const valueA = String(rowA.getValue(columnId) || "").toLowerCase();
                                const valueB = String(rowB.getValue(columnId) || "").toLowerCase();
                                return valueA.localeCompare(valueB);
                            },
                        },
                    ]
                    : []),
                // Dynamic Action Column
                {
                    key: "action",
                    name: "Action",
                    id: "action",
                    header: "Action",
                    accessorKey: "action",
                    hideSearch: true,
                    cell: ({ row }: any) => {
                        const original = row.original;

                        const renderActions = () => {
                            switch (selectedFilter) {
                                case "Home":
                                    return (
                                        <>
                                            <button
                                                className="emptasklist-tbl-btn cursor-pointer"
                                                onClick={() => {
                                                    setSelectedEmail(original);
                                                    setIsPopupOpen(true);
                                                }}
                                            >
                                                <span className="text-sm dark:text-white" title="View"> <img src={PreferencesSystemicon} className="w-6 h-6 object-cover cursor-pointer" alt="" /></span>
                                            </button>
                                            <button
                                                className="emptasklist-tbl-btn cursor-pointer"
                                                onClick={() =>
                                                    navigate("/add_ticket", { state: { emailTicket: original } })
                                                }
                                            >
                                                <span className="text-sm dark:text-white" title="Ticket"> <img src={ticketLineicon} className="w-6 h-6 object-cover cursor-pointer" alt="" /></span>
                                            </button>
                                            <button
                                                className="emptasklist-tbl-btn cursor-pointer"
                                                onClick={() => handleMarkAsFollowUp(original?.id)}
                                            >
                                                <span className="text-sm dark:text-white" title="Mark As Follow-Up"> <img src={emailOpenicon} className="w-6 h-6 object-cover cursor-pointer" alt="" /></span>
                                            </button>
                                            <button
                                                className="emptasklist-tbl-btn cursor-pointer"
                                                onClick={() => handleArchive(original?.id)}
                                            >
                                                <span className="text-sm dark:text-white" title="Archive"><img src={archiveInicon} className="w-6 h-6 object-cover cursor-pointer" alt="" /></span>
                                            </button>
                                        </>
                                    );

                                case "followUp":
                                    return (
                                        <>
                                            <button
                                                className="emptasklist-tbl-btn cursor-pointer"
                                                onClick={() => {
                                                    setSelectedEmail(original);
                                                    setIsPopupOpen(true);
                                                }}
                                            >
                                                <span className="text-sm dark:text-white" title="View"> <img src={PreferencesSystemicon} className="w-6 h-6 object-cover cursor-pointer" alt="" /></span>
                                            </button>
                                            <button
                                                className="emptasklist-tbl-btn cursor-pointer"
                                                onClick={() =>
                                                    navigate("/add_ticket", { state: { emailTicket: original } })
                                                }
                                            >
                                                <span className="text-sm dark:text-white" title="Ticket"> <img src={ticketLineicon} className="w-6 h-6 object-cover cursor-pointer" alt="" /></span>
                                            </button>
                                            <button
                                                className="emptasklist-tbl-btn cursor-pointer"
                                                onClick={() => handleRemoveFollowUp(original?.id)}
                                            >
                                                <span className="text-sm dark:text-white" title="Remove From Follow-up"><img src={emailOpen} className="w-6 h-6 object-cover cursor-pointer" alt="" /></span>
                                            </button>
                                            <button
                                                className="emptasklist-tbl-btn cursor-pointer"
                                                onClick={() => handleArchive(original?.id)}
                                            >
                                                <span className="text-sm dark:text-white" title="Archive"><img src={archiveInicon} className="w-6 h-6 object-cover cursor-pointer" alt="" /></span>
                                            </button>
                                        </>
                                    );

                                case "Archive":
                                    return (
                                        <>
                                            {/* <button
                                        className="emptasklist-tbl-btn cursor-pointer"
                                        onClick={() => { }}
                                    >
                                        <span className="text-sm dark:text-white">Change Status</span>
                                    </button> */}
                                            <button
                                                className="emptasklist-tbl-btn cursor-pointer"
                                                onClick={() => handleRemoveArchive(original?.id)}
                                            >
                                                <span className="text-sm dark:text-white" title="Un-Archive"><img src={archiveInicon} className="w-6 h-6 object-cover cursor-pointer" alt="" /></span>
                                            </button>
                                        </>
                                    );

                                default:
                                    return null;
                            }
                        };

                        return <div className="flex items-center gap-[8px] theme_btn_item">{renderActions()}</div>;
                    },
                },
            ]
        }
    }

    const columns = useMemo(() => getColumns(selectedFilter), [selectedFilter]);

    const formattedData = useMemo(() => {
        if (selectedFilter !== "Ticket" && customerEmailsData && customerEmailsData?.get_all_customer_emails?.status_code === 200) {
            setTotalPages(customerEmailsData?.get_all_customer_emails?.pagination.total_pages)
            const customerEmails = customerEmailsData?.get_all_customer_emails?.customer_emails || [];

            const pageSize = 50;
            const startIndex = (currentPage - 1) * pageSize;

            return customerEmails.map((ce: any, index: number) => {
                const sNo = startIndex + index + 1;

                return {
                    s_no: sNo,
                    id: ce.id,
                    label: ce?.label,
                    attachments_urls: ce?.attachments_urls,
                    agency_name: ce?.agency_name,
                    received_date: format(ce?.received_at, 'MM-dd-yyyy'),
                    from: ce?.sender_email,
                    subject: ce?.subject,
                    email_body: ce?.email_body,
                    thread_id: ce?.thread_id,
                    status: ce?.is_replied === true ? "Replied" : "Not Replied",
                    reply_body: ce?.reply_body,
                    replies: ce?.replies
                };
            });
        } else if (selectedFilter === "Ticket" && customerTicketsData && customerTicketsData?.get_all_tickets?.status_code === 200) {
            const tickets = customerTicketsData?.get_all_tickets?.tickets || [];
            setTotalPages(customerTicketsData?.get_all_tickets?.pagination.total_pages)

            return tickets.map((t: any) => {
                return {
                    title: t.subject,
                    severity: t.priority,
                    created_on: format(t?.opened_at, 'MM-dd-yyyy'),
                    id: t.ticket_id,
                    status: t.status,
                    description: t?.description,
                    attachments_urls: t?.attachments_urls
                };
            });
        } else {
            return [];
        }
    }, [customerEmailsData, customerTicketsData]);

    function paginationhandle(pageNo: number, itemsPerPage: number) {
        setCurrentPage(pageNo);

        if (selectedFilter === "Home" && selectedSubFilter === "All") {
            getAllCustomerEmails({
                variables: {
                    is_archived: false,
                    is_follow_up_required: false,
                    page: pageNo,
                    page_size: 50,
                    start_date: getValues('start_date') ? getValues('start_date') : null,
                    end_date: getValues('end_date') ? getValues('end_date') : null
                }
            });
        } else if (selectedFilter === "Home" && selectedSubFilter === "Replied") {
            getAllCustomerEmails({
                variables: {
                    is_archived: false,
                    is_follow_up_required: false,
                    is_replied: true,
                    page: pageNo,
                    page_size: 50,
                    start_date: getValues('start_date') ? getValues('start_date') : null,
                    end_date: getValues('end_date') ? getValues('end_date') : null
                }
            });
        } else if (selectedFilter === "Home" && selectedSubFilter === "Not Replied") {
            getAllCustomerEmails({
                variables: {
                    is_archived: false,
                    is_follow_up_required: false,
                    is_replied: false,
                    page: pageNo,
                    page_size: 50,
                    start_date: getValues('start_date') ? getValues('start_date') : null,
                    end_date: getValues('end_date') ? getValues('end_date') : null
                }
            });
        } else if (selectedFilter === "followUp") {
            getAllCustomerEmails({
                variables: {
                    is_archived: false,
                    is_follow_up_required: true,
                    page: pageNo,
                    page_size: 50
                }
            });
        } else if (selectedFilter === "Ticket") {
            getAllTickets({
                variables: {
                    page: pageNo,
                    page_size: 50
                }
            });
        } else if (selectedFilter === "Archive") {
            getAllCustomerEmails({
                variables: {
                    is_archived: true,
                    page: pageNo,
                    page_size: 50
                }
            });
        }
    }

    async function handleClearClick() {
        setValue('start_date', null);
        setValue('end_date', null);

        if (selectedFilter === "Home" && selectedSubFilter === "All") {
            getAllCustomerEmails({
                variables: {
                    is_archived: false,
                    is_follow_up_required: false,
                    page: 1,
                    page_size: 50
                }
            });
        } else if (selectedFilter === "Home" && selectedSubFilter === "Replied") {
            getAllCustomerEmails({
                variables: {
                    is_archived: false,
                    is_follow_up_required: false,
                    is_replied: true,
                    page: 1,
                    page_size: 50
                }
            });
        } else if (selectedFilter === "Home" && selectedSubFilter === "Not Replied") {
            getAllCustomerEmails({
                variables: {
                    is_archived: false,
                    is_follow_up_required: false,
                    is_replied: false,
                    page: 1,
                    page_size: 50
                }
            });
        }
    }

    async function handleSearchClick() {
        if (getValues('start_date') && getValues('end_date')) {
            if (selectedFilter === "Home" && selectedSubFilter === "All") {
                getAllCustomerEmails({
                    variables: {
                        is_archived: false,
                        is_follow_up_required: false,
                        page: 1,
                        page_size: 50,
                        start_date: getValues('start_date') ? getValues('start_date') : null,
                        end_date: getValues('end_date') ? getValues('end_date') : null
                    }
                });
            } else if (selectedFilter === "Home" && selectedSubFilter === "Replied") {
                getAllCustomerEmails({
                    variables: {
                        is_archived: false,
                        is_follow_up_required: false,
                        is_replied: true,
                        page: 1,
                        page_size: 50,
                        start_date: getValues('start_date') ? getValues('start_date') : null,
                        end_date: getValues('end_date') ? getValues('end_date') : null
                    }
                });
            } else if (selectedFilter === "Home" && selectedSubFilter === "Not Replied") {
                getAllCustomerEmails({
                    variables: {
                        is_archived: false,
                        is_follow_up_required: false,
                        is_replied: false,
                        page: 1,
                        page_size: 50,
                        start_date: getValues('start_date') ? getValues('start_date') : null,
                        end_date: getValues('end_date') ? getValues('end_date') : null
                    }
                });
            }
        } else {
            showError("Please select Start & end Date")
        }
    }

    async function handleCloseChangePopup() {
        setOpenChangeOpen(false)
        setChangeStatusID('')

        await getAllTickets({
            variables: {
                page: 1,
                page_size: 50
            }
        });
    }

    async function handleRemoveFollowUp(id: string) {
        try {
            const response = await customerEmailAction({
                variables: {
                    id: id,
                    is_follow_up_required: false,
                    is_archived: null,
                    is_replied: null
                }
            });
            if (response.data.customer_email_actions.status_code === 200) {
                showSuccess(response.data.customer_email_actions.message)

                if (selectedFilter === "followUp") {
                    getAllCustomerEmails({
                        variables: {
                            is_archived: false,
                            is_follow_up_required: true,
                            page: 1,
                            page_size: 50
                        }
                    });
                }
                // navigate('/dashboard')
            }
            if (response.data.customer_email_actions.status_code === 400) {
                showError(response.data.customer_email_actions.message)
            }
        } catch (error) {
            if (error instanceof ApolloError) {
                showError(error.message)
            }
        }
    }

    async function handleMarkAsFollowUp(id: string) {
        try {
            const response = await customerEmailAction({
                variables: {
                    id: id,
                    is_follow_up_required: true,
                    is_archived: null,
                    is_replied: null
                }
            });
            if (response.data.customer_email_actions.status_code === 200) {
                showSuccess(response.data.customer_email_actions.message)

                if (selectedFilter === "Home" && selectedSubFilter === "All") {
                    getAllCustomerEmails({
                        variables: {
                            is_archived: false,
                            is_follow_up_required: false,
                            page: 1,
                            page_size: 50,
                            start_date: getValues('start_date') ? getValues('start_date') : null,
                            end_date: getValues('end_date') ? getValues('end_date') : null
                        }
                    });
                } else if (selectedFilter === "Home" && selectedSubFilter === "Replied") {
                    getAllCustomerEmails({
                        variables: {
                            is_archived: false,
                            is_follow_up_required: false,
                            is_replied: true,
                            page: 1,
                            page_size: 50,
                            start_date: getValues('start_date') ? getValues('start_date') : null,
                            end_date: getValues('end_date') ? getValues('end_date') : null
                        }
                    });
                } else if (selectedFilter === "Home" && selectedSubFilter === "Not Replied") {
                    getAllCustomerEmails({
                        variables: {
                            is_archived: false,
                            is_follow_up_required: false,
                            is_replied: false,
                            page: 1,
                            page_size: 50,
                            start_date: getValues('start_date') ? getValues('start_date') : null,
                            end_date: getValues('end_date') ? getValues('end_date') : null
                        }
                    });
                }
                // navigate('/dashboard')
            }
            if (response.data.customer_email_actions.status_code === 400) {
                showError(response.data.customer_email_actions.message)
            }
        } catch (error) {
            if (error instanceof ApolloError) {
                showError(error.message)
            }
        }
    }

    async function handleArchive(id: string) {
        try {
            const response = await customerEmailAction({
                variables: {
                    id: id,
                    is_follow_up_required: null,
                    is_archived: true,
                    is_replied: null
                }
            });
            if (response.data.customer_email_actions.status_code === 200) {
                showSuccess(response.data.customer_email_actions.message)

                if (selectedFilter === "Home" && selectedSubFilter === "All") {
                    getAllCustomerEmails({
                        variables: {
                            is_archived: false,
                            is_follow_up_required: false,
                            page: 1,
                            page_size: 50,
                            start_date: getValues('start_date') ? getValues('start_date') : null,
                            end_date: getValues('end_date') ? getValues('end_date') : null
                        }
                    });
                } else if (selectedFilter === "Home" && selectedSubFilter === "Replied") {
                    getAllCustomerEmails({
                        variables: {
                            is_archived: false,
                            is_follow_up_required: false,
                            is_replied: true,
                            page: 1,
                            page_size: 50,
                            start_date: getValues('start_date') ? getValues('start_date') : null,
                            end_date: getValues('end_date') ? getValues('end_date') : null
                        }
                    });
                } else if (selectedFilter === "Home" && selectedSubFilter === "Not Replied") {
                    getAllCustomerEmails({
                        variables: {
                            is_archived: false,
                            is_follow_up_required: false,
                            is_replied: false,
                            page: 1,
                            page_size: 50,
                            start_date: getValues('start_date') ? getValues('start_date') : null,
                            end_date: getValues('end_date') ? getValues('end_date') : null
                        }
                    });
                } else if (selectedFilter === "followUp") {
                    getAllCustomerEmails({
                        variables: {
                            is_archived: false,
                            is_follow_up_required: true,
                            page: 1,
                            page_size: 50
                        }
                    });
                }
                // navigate('/dashboard')
            }
            if (response.data.customer_email_actions.status_code === 400) {
                showError(response.data.customer_email_actions.message)
            }
        } catch (error) {
            if (error instanceof ApolloError) {
                showError(error.message)
            }
        }
    }

    async function handleRemoveArchive(id: string) {
        try {
            const response = await customerEmailAction({
                variables: {
                    id: id,
                    is_follow_up_required: null,
                    is_archived: false,
                    is_replied: null
                }
            });
            if (response.data.customer_email_actions.status_code === 200) {
                showSuccess(response.data.customer_email_actions.message)

                if (selectedFilter === "Archive") {
                    getAllCustomerEmails({
                        variables: {
                            is_archived: true,
                            page: 1,
                            page_size: 50
                        }
                    });
                }
                // navigate('/dashboard')
            }
            if (response.data.customer_email_actions.status_code === 400) {
                showError(response.data.customer_email_actions.message)
            }
        } catch (error) {
            if (error instanceof ApolloError) {
                showError(error.message)
            }
        }
    }

    async function handleReplyClick(data: any, email: any, attachment: any, links: any) {
        const webHookUrl = selectedFilter === "Home" ? "https://n8n-rrjie-u41909.vm.elestio.app/webhook/reply-canary" : "https://n8n-rrjie-u41909.vm.elestio.app/webhook/follow-up-canary"
        const payload = {
            id: email?.id,
            message_body: data.reply,
            customer_email: email?.from,
            replied_by_name: employeeName,
            replied_by_email: employeeEmail,
            thread_id: email.thread_id,
            is_followup_required: data?.followUpNeeded,
            attachments: attachment,
            links: links,
            employee_id: parseInt(employeeID)
        };

        try {
            setLoading(true);

            const response = await fetch(
                webHookUrl,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(payload),
                }
            );

            if (!response.ok) {
                throw new Error(`Error: ${response.statusText}`);
            }

            const result = await response.text();
            showSuccess(result)

            if (selectedFilter === "Home" && selectedSubFilter === "All") {
                getAllCustomerEmails({
                    variables: {
                        is_archived: false,
                        is_follow_up_required: false,
                        page: 1,
                        page_size: 50,
                        start_date: getValues('start_date') ? getValues('start_date') : null,
                        end_date: getValues('end_date') ? getValues('end_date') : null
                    }
                });
            } else if (selectedFilter === "Home" && selectedSubFilter === "Replied") {
                getAllCustomerEmails({
                    variables: {
                        is_archived: false,
                        is_follow_up_required: false,
                        is_replied: true,
                        page: 1,
                        page_size: 50,
                        start_date: getValues('start_date') ? getValues('start_date') : null,
                        end_date: getValues('end_date') ? getValues('end_date') : null
                    }
                });
            } else if (selectedFilter === "Home" && selectedSubFilter === "Not Replied") {
                getAllCustomerEmails({
                    variables: {
                        is_archived: false,
                        is_follow_up_required: false,
                        is_replied: false,
                        page: 1,
                        page_size: 50,
                        start_date: getValues('start_date') ? getValues('start_date') : null,
                        end_date: getValues('end_date') ? getValues('end_date') : null
                    }
                });
            } else if (selectedFilter === "followUp") {
                getAllCustomerEmails({
                    variables: {
                        is_archived: false,
                        is_follow_up_required: true,
                        page: 1,
                        page_size: 50
                    }
                });
            }

            // Close popup after success
            setIsPopupOpen(false);
        } catch (error) {
            console.error("Failed to send to n8n:", error);
        } finally {
            setLoading(false);
        }
    }

    return (
        <>
            <div id="cts-respon-p-dv" className="w-full flex flex-col items-start justify-start py-40 px-20  mq575:px-5 box-border gap-[20px] max-w-[100%] mq1425:max-w-full">
                <div className="flex flex-col items-start justify-start gap-6 w-full">
                    <BreadCumb />

                    <div className="self-stretch flex flex-row items-center justify-start gap-[5px] text-2xl">
                        <img className="w-6 relative h-6 overflow-hidden shrink-0 cursor-pointer dark-white-img" alt="" src={backArrow}
                            onClick={() => navigate(-1)}
                        />
                        <h3 className="m-0 flex-1 relative text-inherit font-bold font-inherit inline-block max-w-[calc(100%_-_29px)] mq450:text-base dark:text-white">Support Dashboard</h3>
                    </div>
                    <div className="m-0 self-stretch rounded-radius-radius-lg bg-surface-bg-blue darkborder-b-remove flex mq991:grid flex-col items-start justify-start p-8 mq575:p-3 box-border gap-spacing-lg max-w-full mq825:pt-5 mq825:pb-5 mq825:box-border mq1425:pt-[21px] mq1425:pb-[21px] mq1425:box-border">
                        <div className="mb-0">
                            <div className="flex space-x-1 bg-surface rounded-lg p-1 mq825:flex mq825:flex-wrap mq825:gap-2">
                                <button
                                    type="button"
                                    // '[text-decoration:underline] font-semibold active_item_blgs' 
                                    className={`relative link-filterSvgrepo-dv cursor-pointer inactive_item_blgs space-x-2 text-text-secondary hover:text-text-primary hover:bg-surface-hover ${selectedFilter === "Home" ? ' font-semibold active_item_blgs ' : ""}`}
                                    onClick={() => {
                                        setSelectedFilter("Home")
                                        localStorage.setItem("csdashFilter", "Home");
                                    }}
                                >
                                    <span>Home</span>
                                    {/* <span className="px-2 py-0.5 rounded-full text-xs bg-primary text-primary-foreground">5</span> */}
                                </button>
                                <button
                                    type="button"
                                    className={`relative link-filterSvgrepo-dv cursor-pointer inactive_item_blgs space-x-2 text-text-secondary hover:text-text-primary hover:bg-surface-hover ${selectedFilter === "followUp" ? ' font-semibold active_item_blgs' : ""}`}
                                    onClick={() => {
                                        setSelectedFilter("followUp")
                                        localStorage.setItem("csdashFilter", "followUp");
                                    }}
                                >
                                    <span>Follow-Ups Required</span>
                                    {/* <span className="px-2 py-0.5 rounded-full text-xs bg-border text-text-muted">2</span> */}
                                </button>
                                <button
                                    type="button"
                                    className={`relative link-filterSvgrepo-dv cursor-pointer inactive_item_blgs space-x-2 text-text-secondary hover:text-text-primary hover:bg-surface-hover ${selectedFilter === "Ticket" ? ' font-semibold active_item_blgs' : ""}`}
                                    onClick={() => {
                                        setSelectedFilter("Ticket")
                                        localStorage.setItem("csdashFilter", "Ticket");
                                    }}
                                >
                                    <span>Tickets</span>
                                    {/* <span className="px-2 py-0.5 rounded-full text-xs bg-border text-text-muted">4</span> */}
                                </button>
                                <button
                                    type="button"
                                    className={`relative link-filterSvgrepo-dv cursor-pointer inactive_item_blgs space-x-2 text-text-secondary hover:text-text-primary hover:bg-surface-hover ${selectedFilter === "Archive" ? ' font-semibold active_item_blgs' : ""}`}
                                    onClick={() => {
                                        setSelectedFilter("Archive")
                                        localStorage.setItem("csdashFilter", "Archive");
                                    }}
                                >
                                    <span>Archive</span>
                                    {/* <span className="px-2 py-0.5 rounded-full text-xs bg-border text-text-muted">4</span> */}
                                </button>
                            </div>
                        </div>

                        {selectedFilter === "Home" && (
                            <div className="mb-0">
                                <div className="flex space-x-1 bg-surface rounded-lg p-1">
                                    <button
                                        type="button"
                                        className={`relative link-filterSvgrepo-dv cursor-pointer inactive_item_blgs space-x-2 text-text-secondary hover:text-text-primary hover:bg-surface-hover ${selectedSubFilter === "All" ? ' font-semibold active_item_blgs' : ""}`}
                                        onClick={() => {
                                            setSelectedSubFilter("All")
                                            localStorage.setItem("csdashSubFilter", "All");
                                        }}
                                    >
                                        <span>All</span>
                                        {/* <span className="px-2 py-0.5 rounded-full text-xs bg-primary text-primary-foreground">5</span> */}
                                    </button>
                                    <button
                                        type="button"
                                        className={`relative link-filterSvgrepo-dv cursor-pointer inactive_item_blgs space-x-2 text-text-secondary hover:text-text-primary hover:bg-surface-hover ${selectedSubFilter === "Replied" ? ' font-semibold active_item_blgs' : ""}`}
                                        onClick={() => {
                                            setSelectedSubFilter("Replied")
                                            localStorage.setItem("csdashSubFilter", "Replied");
                                        }}
                                    >
                                        <span>Replied</span>
                                        {/* <span className="px-2 py-0.5 rounded-full text-xs bg-border text-text-muted">2</span> */}
                                    </button>
                                    <button
                                        type="button"
                                        className={`relative link-filterSvgrepo-dv cursor-pointer inactive_item_blgs space-x-2 text-text-secondary hover:text-text-primary hover:bg-surface-hover ${selectedSubFilter === "Not Replied" ? ' font-semibold active_item_blgs' : ""}`}
                                        onClick={() => {
                                            setSelectedSubFilter("Not Replied")
                                            localStorage.setItem("csdashSubFilter", "Not Replied");
                                        }}
                                    >
                                        <span>Not Replied</span>
                                        {/* <span className="px-2 py-0.5 rounded-full text-xs bg-border text-text-muted">4</span> */}
                                    </button>
                                </div>
                            </div>
                        )}

                        {selectedFilter === 'Home' && (
                            <div className="grid grid-cols-4 mq1400:grid-4 mq1275:grid-cols-3 mq950:grid-cols-2 mq575:grid-cols-1 mt-[8px] gap-[8px] min-w-full">

                                {/* {(employeeID == "1000064" || employeeID == "1000103" || employeeID == "1000014") && (
                                <SearchableInputsDropdown
                                    label="Employee*"
                                    initialValue={watchAssignedMember}
                                    placeHolder="Select Member"
                                    options={assignedMemberOptions}
                                    onSelect={(key: number, name: string) => {
                                        setValue('assignedMemberID', key);
                                        setValue('assignedMember', name);
                                    }}
                                    errorMessage={errors?.assignedMember}
                                />
                            )} */}

                                <div className="status-filter pb-4 grid gap-[8px]">
                                    <Controller
                                        name="start_date"
                                        control={control}
                                        render={({ field }) => (
                                            <DateSelector
                                                label="Start Date*"
                                                selectedDate={field.value}
                                                onChange={(date: string | any) => {
                                                    const endDate = watch("end_date");
                                                    const result = true;
                                                    if (result) {
                                                        field.onChange(date);
                                                        setValue("end_date", null);
                                                        setValue("start_date", date);
                                                        trigger("start_date");
                                                    }
                                                }}
                                                nothideParsedValue={true}
                                                blueIcon={true}
                                                error={errors.start_date?.message}
                                                showAllDate={true}
                                            />
                                        )}
                                    />
                                </div>
                                <div className="status-filter pb-4 grid gap-[8px]">
                                    <Controller
                                        name="end_date"
                                        control={control}
                                        render={({ field }) => (
                                            <DateSelector
                                                label="End Date*"
                                                selectedDate={field.value}
                                                onChange={(date: string | null | any) => {
                                                    const date2 = parseISO(watch("start_date"));
                                                    const date1 = parseISO(date);
                                                    if (isBefore(date1, date2)) {
                                                        showError(
                                                            "Please select date greater than start date."
                                                        );
                                                    }
                                                    // else if (differenceInDays(date1, date2) > 30) {
                                                    //   showError(
                                                    //     "The selected date range cannot exceed 31 days."
                                                    //   );
                                                    // } 
                                                    else {
                                                        field.onChange(date);
                                                        setValue("end_date", date);
                                                        trigger("end_date");
                                                    }
                                                }}
                                                nothideParsedValue={true}
                                                blueIcon={true}
                                                dontopenDatepicker={!watch("start_date")}
                                                error={errors.end_date?.message}
                                                showAllDate={true}
                                            />
                                        )}
                                    />
                                </div>
                                <div className="flex relative gap-[16px]">
                                    <button onClick={handleSearchClick} className="px-[20px] h-[44px] relative top-[26px] csdashbtn-blg" value="Search">
                                       <img src={searchsIconimg} alt="" className="w-7" />
                                    </button>
                                      <button onClick={handleClearClick} className="px-[15px] h-[44px] relative top-[26px] csdashbtn-blg" value="Clear Deta">
                                       <img src={cleaAlldetaicon} alt="" className="w-10 " />
                                    </button>
                                </div>
                               

                              
                            </div>
                        )}

                        {(formattedData?.length > 0) ? (
                            <div className=" cs-dashboard_blg_main w-full">
                                <DynamicTable
                                    filteredData={formattedData}
                                    selectedColumns={columns}
                                    sorting={sorting}
                                    setSorting={setSorting}
                                    selectedRows={selectedRows}
                                    setSelectedRows={setSelectedRows}
                                    setMainTable={setMainTable}
                                    setMainTableUpdate={setMainTableUpdate}
                                    currentPage={currentPage}
                                    totalPages={totalPages}
                                    handlePageChange={paginationhandle}
                                    showPagination={true}
                                    paginationDataLength={totalPages > 1 || currentPage != 1}
                                />
                            </div>
                        ) : (
                            <div className="self-stretch rounded-lg  overflow-hidden rounded-lg flex flex-col items-center justify-center py-[20px] px-[20px] gap-[8px] text-center text-text-text-secondary mq450:pl-5 mq450:pr-5 mq450:box-border">
                                <div className="self-stretch bg-white rounded-lg bg-slate-100 overflow-hidden dark:bg-slate-700 flex flex-col items-center justify-center py-[110px] px-[53px] gap-[8px] text-center text-text-text-secondary mq450:pl-5 mq450:pr-5 mq450:box-border">
                                    {/* <img
                            className="w-9 h-9 relative overflow-hidden shrink-0"
                            alt=""
                            // src={alertOrAction === "action" ? firsflag1 : iioniconaalertcircleoutline}
                        /> */}
                                    <p className="relative my-0">No data available</p>
                                </div>
                            </div>
                        )}

                        {(customerEmailsLoading || employeesDataLoading || customerEmailActionLoading || customerTicketsLoading) && (
                            <Loader />
                        )}

                        {isPopupOpen && (
                            <ReplyPopup
                                email={selectedEmail}
                                onsubmit={handleReplyClick}
                                back={() => {
                                    setIsPopupOpen(false);
                                }}
                                filter={selectedFilter}
                            />
                        )}

                        {openChangePopup && (
                            <ChangeStatusPriorityPopup
                                ticketID={changeStatusID}
                                isOpen={openChangePopup}
                                onClose={handleCloseChangePopup}
                                refetch={() => { }}
                            />
                        )}
                    </div>
                </div>
            </div>
            {loading && (
                <Loader />
            )}
        </>
    )
}

export default CsDashboard; 